<template>
  <span>
    <DaiCapaGeojson
      id="corrientes_de_agua_canales"
      :url="publicPath+'data/capasv2/05_corrientes_de_agua_clase_canales.geojson'"
      titulo="Canales"
      :estilo-capa="{ stroke: { width: 1.5, color: '#02E1FF' } }"
      tipoGeometria="LineString"
      :z-index="6"
      :renderizarComoImagen="true"
      :visible.sync="visibles.corrientes_de_agua_canales"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="corrientes_de_agua_continuas"
      :url="publicPath+'data/capasv2/05_corrientes_de_agua_clase_continuas.geojson'"
      titulo="Continuas"
      :estilo-capa="{ stroke: { width: 1.5, color: '#0055D3' } }"
      tipoGeometria="LineString"
      :z-index="6"
      :renderizarComoImagen="true"
      :visible.sync="visibles.corrientes_de_agua_continuas"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="corrientes_de_agua_intermitentes"
      :url="publicPath+'data/capasv2/05_corrientes_de_agua_clase_intermitentes.geojson'"
      titulo="Intermitentes"
      :estilo-capa="{ stroke: { width: 1.5, color: '#00A9FF' } }"
      tipoGeometria="LineString"
      :z-index="6"
      :renderizarComoImagen="true"
      :visible.sync="visibles.corrientes_de_agua_intermitentes"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="cuerpos_de_agua_intermitente"
      :url="publicPath+'data/capasv2/05_cuerpos_de_agua_condicion_intermitente.geojson'"
      titulo="Intermitentes"
      :estilo-capa="{
        stroke: { width: 1.5, color: '#00A9FF' },
        fill: { color: '#00A9FF' },
      }"
      tipoGeometria="Polygon"
      :z-index="6"
      :renderizarComoImagen="true"
      :visible.sync="visibles.cuerpos_de_agua_intermitente"
      :use-loader="true"
    />
    <DaiCapaGeojson
      id="cuerpos_de_agua_perenne"
      :url="publicPath+'data/capasv2/05_cuerpos_de_agua_condicion_perenne.geojson'"
      titulo="Continuos"
      :estilo-capa="{
        stroke: { width: 1.5, color: '#3C6FFE' },
        fill: { color: '#3C6FFE' },
      }"
      tipoGeometria="Polygon"
      :z-index="6"
      :renderizarComoImagen="true"
      :visible.sync="visibles.cuerpos_de_agua_perenne"
      :use-loader="true"
    />
  </span>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      visibles: {
        corrientes_de_agua_canales: false,
        corrientes_de_agua_continuas: false,
        corrientes_de_agua_intermitentes: false,
        cuerpos_de_agua_intermitente: false,
        cuerpos_de_agua_perenne: false,
      },
      publicPath: process.env.BASE_URL,
    };
  },
  computed: {
    ...mapState("mapa", ["temasExpandidos"]),
    esteTemaActivo() {
      return this.temasExpandidos.hidrografia;
    },
  },
  beforeMount(){
    let nv = this.esteTemaActivo;
    this.visibles.corrientes_de_agua_canales = nv;
    this.visibles.corrientes_de_agua_continuas = nv;
    this.visibles.corrientes_de_agua_intermitentes = nv;
    this.visibles.cuerpos_de_agua_intermitente = nv;
    this.visibles.cuerpos_de_agua_perenne = nv;
  },
  watch: {
    esteTemaActivo(nv) {
      this.visibles.corrientes_de_agua_canales = nv;
      this.visibles.corrientes_de_agua_continuas = nv;
      this.visibles.corrientes_de_agua_intermitentes = nv;
      this.visibles.cuerpos_de_agua_intermitente = nv;
      this.visibles.cuerpos_de_agua_perenne = nv;
    },
  },
};
</script>